import { Component, OnDestroy, OnInit } from '@angular/core';
import { TicketInfo } from '@shared/models/ticket-info';
import { takeWhile } from 'rxjs/operators';
import { TicketManager } from '@routes/ticket-manager';
import { Constants } from '@shared/constants/constants';
import { ApiService } from '@shared/apis';
import { AuthService } from '@core/auth/auth.service';
import { Company } from '@shared/enums/company';
import Role from '@shared/constants/role';

@Component({
  selector: 'app-detail-info',
  templateUrl: './detail-info.component.html',
  styleUrls: ['./detail-info.component.scss']
})
export class DetailInfoComponent implements OnInit, OnDestroy {


  changeLogs: any[] = [];
  serviceCenterTel: number;
  serviceCenterName: string;
  serviceCenterAscNo: number;

  subscription: any = {};
  ticketInfo: TicketInfo;
  readonly constants = Constants;
  companies = Company;
  company;
  isDealerManager;
  isDealerStaff;
  isAdmin;

  inboundTrackingUrl: string;
  outboundTrackingUrl: string;
  pickUpService: string;
  protected readonly Constants = Constants;
  private alive = true;

  constructor(protected ticketManager: TicketManager,
              private authService: AuthService,
              private apiService: ApiService,) {
    this.company = this.authService.getCurrentCompany();
    this.isDealerStaff = this.authService.getRolesByCompany(this.company).includes(Role.seaImDealerStaff);
    this.isDealerManager = this.authService.getRolesByCompany(this.company).includes(Role.seaImDealerSuperVisor);
    this.isAdmin = this.authService.getRolesByCompany(this.company).includes(Role.admin);
    this.pickUpService = Constants.serviceCode.PICKUP_SERVICE;
  }

  ngOnInit(): void {
    const setChangeLogs = (ticketInfo) => {
      this.changeLogs = ticketInfo?.changeLogs?.reverse();
    };

    this.subscription.ticketEdit = this.ticketManager.activeTicket$
      .pipe(takeWhile(() => this.alive))
      .subscribe(ticket => {
        if (!ticket) {
          return;
        }

        if (this.subscription.ticketEdit) {

          ticket.ticketChanged$
            .pipe(takeWhile(() => this.alive))
            .subscribe(ticketInfo => {
              if (ticketInfo) {
                this.ticketInfo = ticketInfo;
                setChangeLogs(ticketInfo);
              }
            });

          this.subscription.ticketEdit.unsubscribe();
          return;
        }

        const { ticketInfo } = ticket;
        if (!ticketInfo.serviceCenter) {
          this.apiService.ticket.getTicket(ticketInfo.ticketNo).pipe().subscribe(
            res => {
              this.assignEachValues(res);
            })
        } else {
          this.assignEachValues(ticketInfo);
        }
        this.ticketInfo = ticketInfo;
        setChangeLogs(ticketInfo);
        this.getTrackingUrls(ticketInfo);
      });
  }

  ngOnDestroy() {
    this.alive = false;
  }

  assignEachValues(info) {
    this.serviceCenterAscNo = info.serviceCenter?.ascNo;
    this.serviceCenterName = info.serviceCenter?.name;
    const tel: string = info.serviceCenter?.tel || '';
    this.serviceCenterTel = info.serviceCenter?.tel;
  }

  formattingPhoneNumber(tel) {

    this.serviceCenterTel = tel.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }

  getTrackingUrls(ticketInfo) {
    const ups = /^1Z/i;
    this.inboundTrackingUrl = ticketInfo?.shipments?.inbound && ticketInfo?.shipments?.inbound.match(ups) ?
      `https://www.ups.com/track?tracknum=${ ticketInfo?.shipments?.inbound }` : null;
    this.outboundTrackingUrl = ticketInfo?.shipments?.outbound && ticketInfo?.shipments?.inbound.match(ups) ?
      `https://www.ups.com/track?tracknum=${ ticketInfo?.shipments?.outbound }` : null;
  }
}
